import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './private-placard.module.css';

interface Props {
  accountName?: string;
}

export const PrivatePlacard: FC<Props> = ({ accountName }) => (
  <div data-cy="task_drawer.private_task.banner" className={styles.container}>
    <div className={styles.icon}>
      <ViewOff16 />
    </div>
    <div className={styles.label}>
      <FormattedMessage id="task.private.label" />
      <strong className={styles.label__account}>{accountName}</strong>
    </div>
  </div>
);
